import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/context/SeoContext";

const renderBody = (body) => {
  const nodes = [];
  let para = [];
  const flush = () => {
    if (para.length) {
      nodes.push(
        <p key={`p-${nodes.length}`} className="mt-3 text-sm leading-relaxed text-bark-soft sm:text-base">
          {para.join(" ")}
        </p>
      );
      para = [];
    }
  };
  body.split(/\n/).forEach((line) => {
    const t = line.trim();
    if (!t) {
      flush();
    } else if (t.startsWith("## ")) {
      flush();
      nodes.push(
        <h2 key={`h-${nodes.length}`} className="mt-8 font-serif text-xl font-semibold text-bark sm:text-2xl">
          {t.replace(/^##\s+/, "")}
        </h2>
      );
    } else {
      para.push(t);
    }
  });
  flush();
  return nodes;
};

export default function LegalPage({ docId }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setDoc(null);
    setError(false);
    api
      .get(`/legal/${docId}`)
      .then(({ data }) => setDoc(data))
      .catch(() => setError(true));
  }, [docId]);

  if (error) {
    return (
      <div data-testid="legal-error" className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-8">
        <p className="font-serif text-2xl text-bark">Document introuvable</p>
      </div>
    );
  }

  if (!doc) {
    return (
      <div className="flex items-center justify-center gap-3 py-32 text-bark-soft">
        <Loader2 className="animate-spin text-amber-deep" size={26} />
        <span className="font-serif text-lg">Chargement…</span>
      </div>
    );
  }

  const updated = doc.updated_at ? new Date(doc.updated_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : null;

  return (
    <article data-testid={`legal-page-${docId}`} className="mx-auto max-w-3xl px-4 py-16 sm:px-8">
      <Seo pageKey={docId} title={`${doc.title} | Pétales de Miel`} />
      <p className="eyebrow">Informations légales</p>
      <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight text-bark sm:text-5xl">{doc.title}</h1>
      {updated && (
        <p data-testid="legal-updated" className="mt-3 text-sm text-stone-mute">Dernière mise à jour : {updated}</p>
      )}
      <div className="mt-6 border-t border-amber-900/10 pt-2">{renderBody(doc.body || "")}</div>
    </article>
  );
}
